// @generated from regex-gen.ts
export const WHITE_SPACE_REGEX: RegExp = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i
